// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__QOOQr","main":"Layout_main__KEOXS","inner-block":"Layout_inner-block__0VAq1","innerBlock":"Layout_inner-block__0VAq1"};